<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="10" md="10" lg="4">
        <div class="layout column align-center">
          <img src="../../assets/log.png" alt="Vue Material Admin" height="140px" width="155px" />

          <v-card width="400px" class="pa-3">
            <v-card-title>Registro</v-card-title>
            <v-card-text>
              <div class="layout column align-center">
                <i
                  class="flex my-4 black--text"
                >Favor llenar los campos con la informacion requerida</i>
              </div>
              <v-form v-model="valid">
                <v-text-field
                  color="#F28122"
                  label="Cedula"
                  type="text"
                  :change="getUserByRNC(register.identificationCard)"
                  v-mask="'DDD-DDDDDDD-D'"
                  v-model="register.identificationCard"
                  :error="error"
                  :rules="[rules.required]"
                />
                <v-text-field
                  color="#F28122"
                  name="nombre"
                  label="Nombre"
                  type="text"
                  v-model="register.name"
                  :error="error"
                  :rules="[rules.required]"
                />
                <v-text-field
                  color="#F28122"
                  name="login"
                  label="Apellido"
                  type="text"
                  v-model="register.lastName"
                  :error="error"
                  :rules="[rules.required]"
                />

                <v-text-field
                  color="#F28122"
                  :type="hidePassword ? 'password' : 'text'"
                  :append-icon="hidePassword ? 'visibility_off' : 'visibility'"
                  name="password"
                  label="Contraseña"
                  id="password"
                  :rules="[rules.required]"
                  v-model="register.password"
                  :error="error"
                  @click:append="hidePassword = !hidePassword"
                />
                <v-text-field
                  color="#F28122"
                  :type="hidePassword ? 'password' : 'text'"
                  :append-icon="hidePassword ? 'visibility_off' : 'visibility'"
                  name="password"
                  label="Repetir Contraseña"
                  id="password"
                  :rules="[rules.required]"
                  v-model="register.repitPassword"
                  :error="error"
                  @click:append="hidePassword = !hidePassword"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                block
                color="primary"
                :disabled="!valid ? isEnabled : (isEnabled = false)"
                :loading="loading"
                @click="registerUser"
              >Registar</v-btn>
            </v-card-actions>
            <div class="layout column">
              <p class="flex my-4 black--text">
                Al presionar registrar, acepto las Condiciones de uso y el Aviso
                de privacidad
              </p>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-snackbar v-model="showResult" :timeout="2000" top>
      {{
      result
      }}
    </v-snackbar>

    <v-dialog v-model="dialog" persistent max-width="306">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>

        <v-card-text class="subtitle-1 font-weight-medium">
          {{
          message
          }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text to="/login" v-if="isSuccessful">INICAR SESION</v-btn>

          <v-btn color="green darken-1" text @click="dialog = false" v-if="!isSuccessful">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
const axios = require("axios");
export default {
  data: () => ({
    dialog: false,
    valid: false,
    isEnabled: true,
    message: "",
    title: "",
    isSuccessful: true,
    register: {
      identificationCard: "",
      name: "",
      lastName: "",
      password: "",
      repitPassword: "",
      url: "",
    },
    loading: false,
    hidePassword: true,
    error: false,
    showResult: false,
    result: "",
    lastRnc: "",
    rules: {
      required: (value) => !!value || "Campo requerido.",
    },
  }),
  methods: {
    ...mapActions(["registerMethod"]),
    async getUserByRNC(rnc) {
      if (this.validateCardId() && rnc != this.lastRnc) {
        let self = this;
        console.log(rnc);
        this.lastRnc = rnc;
        axios
          .get(`http://45.186.14.5:7002/api/publico/clienteporcedula/${rnc}`)
          .then((response) => {
            if (response.data) {
              this.title = "Datos no encontrados";
              this.message =
                "Actualmente no tiene un servicio contratado con nosotros , por favor pasar por una de nuestras oficinas.";
              this.isSuccessful = false;
              this.isEnabled = true;
              self.dialog = true;
              return;
            }
            register.name = response.data.nombre_cli;
          })
          .catch((e) => {
            error();
            this.overlay = false;
          });
      }else{
            self.color = "Informacion";
            self.showResult = true;
            self.loading = false;
            self.result = "Cedula invalidad";
         }
    },
    async registerUser() {
      try {
        this.loading = true;
        let self = this;
        if (this.valid) {
          if (this.validateCardId()) {
            const reponse = await this.registerMethod(this.register);
            if (reponse) {
              this.dialog = true;
              this.title = "Informacion";
              this.message = "Registro Exitoso!";
              this.isSuccessful = true;
              self.dialog = true;
              this.loading = false;
              this.register = {};
            } else {
              this.title = "Informacion";
              this.message = "Intente mas tarde";
              this.isSuccessful = false;
              self.dialog = true;
              this.loading = false;
            }
          } else {
            self.color = "Informacion";
            self.showResult = true;
            self.loading = false;
            self.result = "Cedula invalidad";
          }
        }
      } catch (e) {
        this.title = "Informacion";
        this.message = "Intente mas tarde";
        this.isSuccessful = false;
        self.dialog = true;
        this.loading = false;
      }
    },
    validateCardId() {
      if (this.register.identificationCard.length == 13) {
        return true;
      }

      return false;
    },
  },
};
</script>
